import { type Html, html, View } from 'rune-ts';
import klass from './Business.module.scss';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { UtilImageS } from '@modules/Util/Image/S/Function/module/UtilImageS';

const mapImageToHtml = (imgs: { src: string; name: string }[]) => {
  return imgs.map(
    ({ src, name }) =>
      html`<div class="${klass.marquee_item}">
        <div class="${klass.img_wrapper}">
          <img
            src="${UtilImageS.getResizedUrl({ url: src, quality: 85, width: 112 * 2, format: 'webp' })}"
            alt="marquee-product"
          />
        </div>
        <div class="${klass.name}  ${font('18_semibold')}">${name}</div>
      </div>`,
  );
};

const upper_creator_images = mapImageToHtml([
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/07eea1968f6937363f78135a75cb3fd8bb7176ae1.png',
    name: '고마우시다',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/97031cec752922958d30bbae37fff7057831dce02.png',
    name: '낙디',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/22f483cac813f06ae8b40c6e8e24eb5b8fa080873.png',
    name: '햄뿡이',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/0896db121db3954cc8b4b754dd57be7c73e2fd0a4.png',
    name: '만디',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/cf216cff161232974cf9ec700ad80bd817ec44e35.png',
    name: '만장',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/8cd459c5f2843a50b149ff545ae1c31bfa9239016.png',
    name: '박키',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/a3cd1429873b1b5fc1618310967cbb0cec6808ce7.png',
    name: '오늘도앤님',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/7089d6d420d9830b5f8f8b6b392fb32632f87d428.png',
    name: '도아마',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/bb07abf55313d8ef9d8e435c8edc1492bc0b6a2d2.webp',
    name: '파스게티',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/3d7a5dc5824b8be9a6ce35242e8bdbd8e53872f91.webp',
    name: '찌그러진 누룽쥐',
  },
]);
const lower_creator_images = mapImageToHtml([
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/2ae59cfb7847c2cac679d8c4735fb0d066b29f7b1.png',
    name: '셀러리군은 샐러리맨',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/f56fd3b7f9278fc11f274b5b29ce05623609cb772.png',
    name: '갓핑키',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/4403d538349726b0d6234d111231f4a58cddfc283.png',
    name: '카코이 유이',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/cac23a489020120cf979591f3b107399adec18444.png',
    name: '소금이',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/596de6016458015a08ea836d791840c5f002189c5.png',
    name: '열심히살아야되는햄버거',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/2956b3fcdf1ff92fde3b02e45f4cd67e7d2d33b76.png',
    name: '이치카 히비',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/c9766eaf779529c8761a0c3f1ea6c75b1a6585657.png',
    name: '야옹이즘',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/6d3be9d79f4385e26a53b7b375a72e052a2963758.png',
    name: '걱정장인',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/29cc58e82dc005b73fe5a379cbdf47e4a2f986649.png',
    name: '버터감자',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/cdf8915bc097453bf1e4367a32fbefca11bda6a910.png',
    name: '셀데아',
  },
  {
    src: '//s3.marpple.co/files/u_29089/2025/11/original/e164ee895c55bb424409a5a7bfb5c7e60c3120e111.png',
    name: '유봄냥',
  },
]);

export class BusinessSection extends View<{ is_mobile: boolean }> {
  override template(): Html {
    return html`
      <section class="${klass.container}">
        <div class="${klass.content}">
          <div class="${staticFont('bebas_20_bold')}">CHAPTER 6.</div>
          <div class="${font('48_bold', '28_bold')}">
            이미 많은 크리에이터가<br />마플샵과 함께 하고 있어요
          </div>
        </div>
        <div class="${klass.business_list}">
          <div class="${klass.marquee_wrapper} ${klass.top}">
            <div class="${klass.marquee_background}">${upper_creator_images}</div>
            <div class="${klass.marquee_background}" aria-hidden="true">${upper_creator_images}</div>
            <div class="${klass.marquee_background}" aria-hidden="true">${upper_creator_images}</div>
          </div>
          <div class="${klass.marquee_wrapper} ${klass.bottom}">
            <div class="${klass.marquee_background}">${lower_creator_images}</div>
            <div class="${klass.marquee_background}" aria-hidden="true">${lower_creator_images}</div>
            <div class="${klass.marquee_background}" aria-hidden="true">${lower_creator_images}</div>
          </div>
        </div>
        <div class="${klass.button_wrapper}">
          <a
            href="https://tally.so/r/3xBxgy"
            target="_blank"
            class="${klass.apply_button} goods_partners__apply_button_top"
          >
            <div class="${font('28_bold', '16_bold')}">지금 바로 지원하기</div>
          </a>
        </div>
      </section>
    `;
  }
}
